<template>
  <div>
    <v-container class="container px-0">
      <v-row
        class="title-row"
        :class="`${
          $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
        }`"
      >
        <v-col class="d-flex align-center">
          <h4 class="font-weight-light">
            {{ $t("heading.reseller.page.logs") }}
          </h4>
        </v-col>

        <v-col
          class="page-title__filter-controls justify-end align-end"
          :class="[`${$vuetify.breakpoint.mobile ? 'pb-3' : ''}`]"
        >
          <DataIteratorFilterControls
            :showSearchTerm="true"
            :searchTerm="searchTerm"
            :fullWidthSearch="false"
            :fullWidthLg="false"
            :fullWidthMd="true"
            @update:searchTerm="searchTerm = $event"
            :class="'my-hostings-search'"
          ></DataIteratorFilterControls>

          <!-- <v-btn
            :large="!$vuetify.breakpoint.smAndDown"
            elevation="0"
            color="primary"
            class="p-2 add-new-button page-title__add-button"
          >
            <v-icon :class="$vuetify.breakpoint.mobile ? 'mr-0' : ''"
              >$plus
            </v-icon>
            {{ $vuetify.breakpoint.mobile ? "" : $t("button.domain.add") }}
          </v-btn> -->
        </v-col>
      </v-row>
    </v-container>

    <v-container class="px-0">
      <v-row>
        <v-col cols="12">
          <v-card elevation="4" class="data-table">
            <v-data-table
              :loading="fetchingLogs"
              :headers="headers"
              :items="logs"
              item-key="id"
              must-sort
              calculate-widths
              disable-pagination
              hide-default-header
              hide-default-footer
              class="elevation-0 custom-data-table logs-table"
              :options.sync="options"
            >
              <template v-slot:no-data>
                <data-iterator-no-results-container
                  v-if="searchTerm"
                  @clearAllFilters="clearFilters()"
                  :searchTerm="searchTerm"
                />
                <div v-else class="no-data-container">
                  <no-data-table-logs class="mb-6"/>
                  <h6 class="no-data-container__title mb-4 font-weight-bold">{{ $t('reseller.logs.noLogs') }}</h6>
                  <p class="no-data-container__description mb-0">{{ $t('reseller.logs.noLogsDesc') }}</p>
                </div>
              </template>
              <template v-if="fetchingLogs" v-slot:body>
                <template v-if="$vuetify.breakpoint.lgAndDown">
                  <logs-table-item-skeleton-mobile
                    v-for="item in 5"
                    :key="item"
                  />
                </template>
                <template v-else>
                  <logs-table-skeleton-item :cols="4" />
                </template>
              </template>
              <template
                v-if="!$vuetify.breakpoint.mobile && !fetchingLogs && logs.length"
                v-slot:header="{ props }"
              >
                <tr class="custom-sort">
                  <td
                    v-for="header in props.headers"
                    :key="header.value"
                    class="sort-item"
                    @click="header.sortable && toggleSort(header)"
                  >
                    <div
                      class="custom-sort__item"
                      :class="{
                        'custom-sort__item--sortable': header.sortable,
                      }"
                    >
                      {{ $t(`table.header.${header.text}`) }}
                      <div class="custom-sort__arrows" v-if="header.sortable">
                        <v-icon
                          size="12"
                          class="custom-sort__arrow-up"
                          :up="
                            !props.options.sortDesc[0] &&
                            props.options.sortBy[0] === header.value
                          "
                          :down="
                            props.options.sortDesc[0] &&
                            props.options.sortBy[0] === header.value
                          "
                        >
                          $arrowsSort
                        </v-icon>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <template
                v-if="$vuetify.breakpoint.mobile"
                v-slot:item="{ item, headers }"
              >
                <tr>
                  <td class="w-100 text-start">
                    <div class="mobile-table-item">
                      <div class="mobile-table-item__values">
                        <div
                          class="mobile-table-item__row"
                          v-for="header in headers"
                          :key="header.value"
                        >
                          <div class="mobile-table-item__header">
                            {{ $t(`table.header.${header.text}`) }}
                          </div>
                          <div class="mobile-table-item__value">
                            <LogsTableCell
                              :item="item"
                              :header="header"
                              isMobile
                              @action-button-delete="
                                $refs.UserDeleteModal.open($event)
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else v-slot:item="{ item, headers }">
                <tr>
                  <td v-for="header in headers" :key="header.value" class="text-start">
                    <LogsTableCell
                      :item="item"
                      :header="header"
                      @action-button-delete="$refs.UserDeleteModal.open($event)"
                    />
                  </td>
                </tr>
              </template>
              <template v-slot:footer>
                <div v-if="logs.length">
                  <v-row
                    class="data-iterator-footer my-3 mx-4"
                    align="center"
                    justify="center"
                  >
                    <v-pagination
                      v-model="options.page"
                      :length="numberOfPages ? numberOfPages : 1"
                      :total-visible="9"
                      next-icon="$paginationright"
                      prev-icon="$paginationleft"
                      elevation="0"
                      outlined
                    >
                    </v-pagination>

                    <v-spacer v-if="!$vuetify.breakpoint.mobile"></v-spacer>
                    <div
                      class="data-iterator-page-number"
                      v-if="!$vuetify.breakpoint.mobile"
                    >
                      <span>{{ $t("table.footer.log") }}</span>
                      <v-btn
                        v-for="(item, index) in possibleItemsPerPage"
                        :key="index"
                        elevation="0"
                        @click="
                          options.itemsPerPage = possibleItemsPerPage[index]
                        "
                        :class="
                          options.itemsPerPage === possibleItemsPerPage[index]
                            ? 'active'
                            : ''
                        "
                      >
                        {{ possibleItemsPerPage[index] }}
                      </v-btn>
                    </div>
                  </v-row>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Api from "../../apis/Api";
import LogsTableCell from "./LogsTableCell.vue";
import LogsTableItemSkeletonMobile from "../../components/dataIterator/tables/LogsTableItemSkeletonMobile.vue";
import LogsTableSkeletonItem from "../../components/dataIterator/tables/LogsTableSkeletonItem.vue";
import DataIteratorFilterControls from "../../components/dataIterator/DataIteratorFilterControls.vue";
import DataIteratorNoResultsContainer from "../../components/dataIterator/DataIteratorNoResultsContainer.vue";
import NoDataTableLogs from "../../components/icons/noDataTableLogs.vue";

export default {
  components: {
    LogsTableCell,
    LogsTableItemSkeletonMobile,
    LogsTableSkeletonItem,
    DataIteratorFilterControls,
    DataIteratorNoResultsContainer,
    NoDataTableLogs,
  },
  mixins: {},
  props: {},
  data() {
    return {
      fetchingLogs: false,
      logs: [],
      itemsTotal: 0,
      options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ["date"],
        sortDesc: [true],
      },
      possibleItemsPerPage: [10, 20,50, 75, 100],
      searchTerm: "",
      headers: [
        {
          text: "user",
          value: "user",
          sortable: false,
        },
        {
          text: "instance",
          value: "instance",
          sortable: false,
        },
        {
          text: "actions",
          value: "action",
          sortable: false,
        },
        {
          text: "date",
          value: "date",
          align: "end",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.itemsTotal / this.options.itemsPerPage);
    },
  },
  created() {},
  mounted() {
    this.fetchLogs();
  },
  watch: {
    "options.page"() {
      this.fetchLogs();
    },
    "options.itemsPerPage"() {
      this.options.page = 1;
      this.fetchLogs();
    },
    "options.sortBy.0"() {
      this.options.page = 1;
      this.fetchLogs();
    },
    "options.sortDesc.0"() {
      this.options.page = 1;
      this.fetchLogs();
    },
    searchTerm() {
      this.options.page = 1;
      this.fetchLogs();
    },
  },
  methods: {
    fetchLogs() {
      this.fetchingLogs = true;

      const params = new URLSearchParams({
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort_by: this.options.sortBy[0],
        sort_dir: this.options.sortDesc[0] ? "desc" : "asc",
      });

      if (this.searchTerm) {
        params.append("search_term", this.searchTerm);
      }
      Api.get(`/reseller/instances-logs?${params.toString()}`)
        .then((response) => {
          this.logs = response.data.data;
          this.itemsTotal = response.data.total || response.data.meta?.total || 0;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.fetchingLogs = false;
        });
    },
    toggleSort(header) {
      if (this.options.sortBy[0] === header.value) {
        this.options.sortDesc = [!this.options.sortDesc[0]];
        return;
      }
      this.options.sortBy = [header.value];
    },
    clearFilters() {
      this.searchTerm = "";
    },
  },
};
</script>
<style src="../../components/dataIterator/TableCustomSort.scss" lang="scss" scoped />
<style src="../../components/dataIterator/DataIteratorFooter.scss" lang="scss" scoped />
